/* 22/10 : glissement retiré (Lancelot : ça saute) — fondu seul, aucun mouvement.
   Maison Alméa 24/09 — les sections du bas apparaissent en douceur quand on descend.
   Uniquement un fondu + léger glissement (opacity / transform) : AUCUN changement de taille
   ni de position dans la page, donc aucun saut. Le haut de page n'est jamais touché.
   (Différent de k-reveal Kissaki : pas de content-visibility, qui faisait sauter la page.)
   Retour arrière : retirer la ligne alm-apparition.js dans layout/theme.liquid. */
(function () {
  if (window.__almApp) return; window.__almApp = 1;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var st = document.createElement('style');
  st.textContent = '.alm-app{opacity:0;transform:none}' +
    '.alm-app.alm-app-in{opacity:1;transform:none;transition:opacity .6s cubic-bezier(.2,.7,.2,1),transform .6s cubic-bezier(.2,.7,.2,1)}';
  document.head.appendChild(st);
  function fixe(s) {
    var els = s.querySelectorAll('*'), n = Math.min(els.length, 400);
    for (var i = 0; i < n; i++) { var p = getComputedStyle(els[i]).position; if (p === 'fixed' || p === 'sticky') return true; }
    return false;
  }
  function go() {
    var vh = window.innerHeight || 800;
    var list = document.querySelectorAll('#MainContent > .shopify-section');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('alm-app-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    for (var i = 0; i < list.length; i++) {
      var s = list[i];
      if (i === 0 || s.offsetHeight < 40) continue;
      if (s.getBoundingClientRect().top < vh * 1.05) continue;   /* déjà visible (ou presque) : on n'y touche pas */
      if (fixe(s)) continue;                                      /* tiroirs, barres collantes : jamais */
      s.classList.add('alm-app');
      io.observe(s);
    }
    /* filet de sécurité : si l'observateur ne se déclenche pas, on révèle au défilement */
    function verif() {
      var reste = document.querySelectorAll('.alm-app:not(.alm-app-in)');
      if (!reste.length) { window.removeEventListener('scroll', verif); return; }
      var lim = (window.innerHeight || 800) * 0.95;
      for (var j = 0; j < reste.length; j++) { if (reste[j].getBoundingClientRect().top < lim) reste[j].classList.add('alm-app-in'); }
    }
    window.addEventListener('scroll', verif, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
